import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {SearchResult} from '../_models/SearchResult';
import {Tracciato, TracciatoField} from '../_models/_Index';
import { firstValueFrom } from 'rxjs';

// const cachePrefix = 'archiconnect-v2-';

@Injectable({ providedIn: 'root' })
export class TracciatiService {
  constructor(private http: HttpClient) {}

  async getTracciatiFilteredAsync(orgId: number, search: string, page: number, count: number, sortField: string, sortAsc: boolean) {
    return firstValueFrom(this.http.post<SearchResult<Tracciato>>(`${environment.localApiUrl}api/Tracciati/TracciatiFiltered?orgId=${orgId}`,
      { search, page, count, sortField, sortAsc }));
  }

  async getTracciatoAsync(orgId: number, code: string) {
    return firstValueFrom(this.http.get<Tracciato>(`${environment.localApiUrl}api/Tracciati/Tracciato?orgId=${orgId}&code=${code}`));
  }

  async getTracciatoFromIdAsync(orgId: number, tracciatoId: number) {
    return firstValueFrom(this.http.get<Tracciato>(`${environment.localApiUrl}api/Tracciati/TracciatoFromId?orgId=${orgId}&tracciatoId=${tracciatoId}`));
  }

  async createTracciatoAsync(tracciato: Tracciato) {
    return firstValueFrom(this.http.post<Tracciato>(`${environment.localApiUrl}api/Tracciati/CreateTracciato`, tracciato));
  }

  async updateTracciatoAsync(tracciato: Tracciato) {
    return firstValueFrom(this.http.post<Tracciato>(`${environment.localApiUrl}api/Tracciati/UpdateTracciato`, tracciato));
  }

  async deleteTracciatoAsync(orgId: number, code: string) {
    return firstValueFrom(this.http.get<string>(`${environment.localApiUrl}api/Tracciati/DeleteTracciato?orgId=${orgId}&code=${code}`));
  }

  async getFieldsOfTracciatiAsync(tracciatoId: number) {
    return firstValueFrom(this.http.get<SearchResult<TracciatoField>>(`${environment.localApiUrl}api/Tracciati/GetFieldsOfTracciato?tracciatoId=${tracciatoId}`));
  }

  async createTracciatoFieldAsync(field: TracciatoField) {
    return firstValueFrom(this.http.post<TracciatoField>(`${environment.localApiUrl}api/Tracciati/CreateTracciatoField`, field));
  }

  async updateTracciatoFieldAsync(field: TracciatoField) {
    return firstValueFrom(this.http.post<TracciatoField>(`${environment.localApiUrl}api/Tracciati/UpdateTracciatoField`, field));
  }

  async deleteTracciatoFieldAsync(tracciatoId: number, fieldId: number) {
    return firstValueFrom(this.http.get<number>(`${environment.localApiUrl}api/Tracciati/DeleteTracciatoField?tracciatoId=${tracciatoId}&fieldId=${fieldId}`,{}));
  }
}
